const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins
export class HowToWear extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 5) return
    this.carousel = this.setupCarousel()
  }

  setupCarousel() {
    return new KeenSlider(
      this,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2,
          spacing: 20,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 4,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ]
    )
  }
}

if (!customElements.get('how-to-wear')) {
  customElements.define('how-to-wear', HowToWear)
}
